<div soho-busyindicator
  [style.height]="'100%'"
  [text]="' '"
  [blockUI]="true"
  [displayDelay]="20"
  [timeToComplete]="this.uiLoadingIndicatorTimeout"
  [transparentOverlay]="false"
  >
  @if (displayMultiRootNavigation) {
    <div class="hyperlink-container">
      <button (click)="loadMultiRoot()" class="hyperlink">Back To Top</button>
    </div>
  }

  <!-- Leaf template for hierarchy control -->
  @if (leafTemplate) {
    <soho-hierarchy-leaf-template [innerHtml]="leafTemplate"></soho-hierarchy-leaf-template>
  }

  @if (recordCount > 0) {
    @if (data) {
      <figure
        soho-hierarchy
        #SohoHierarchy
        [dataset]="data"
        [templateId]="leafTemplateId"
        [legend]="legend"
        [legendKey]="legendKey"
        [layout]="'stacked'"
        [attr.id]="hierarchyChartId"
        (selected)="onRowsSelected($event)"
        (doubleClick)="onDoubleClick($event)"
        >
      </figure>
    }
  }

  @if (showEmptyMessage) {
    <div soho-emptymessage [emptyMessageOptions]="emptyMessage"></div>
  }
</div>
